const statisticLangs = {
  title: "Thống kê",
  sumary: "Thống kê tổng quát",
  invidual: "Thống kê cá nhân",
  customer: "Doanh số khách hàng",
  debit: "Doanh sách công nợ",
  debitCompany: {
    title: "Danh sách công nợ",
  },
  debitCompanyDetail: {
    title: "Danh sách chi tiết công nợ",
  },
  revenueCompany: {
    title: "Danh sách doanh số khách hàng",
  },
  revenueCompanyDetail: {
    title: "Chi tiết doanh số",
  },
};
export default statisticLangs;
